<template>
  <div class="w-full items-center">
    <vue-progress-bar></vue-progress-bar>
    <div class="w-full lg:w-1/2 md:w-1/2">
      <InvitePeople v-if="endorsementInviteStep === 0" />
      <ProgressMeasure v-else-if="endorsementInviteStep === 1" />
      <vs-prompt
        :title="$t('skillDetails.action1.a1')"
        :accept-text="$t('skillDetails.action1.a3')"
        :cancel-text="$t('skillDetails.action1.a4')"
        @cancel="confirmSendEndorsementInvite = false"
        @accept="sendEndorsementInvite"
        @close="confirmSendEndorsementInvite = false"
        :active.sync="confirmSendEndorsementInvite">
        <div class="con-exemple-prompt">
          <div class="mb-3">{{$t('skillDetails.action1.a2')}} <b>{{formatDate(feedback_sent_dates[0])}}</b> {{$t('skillDetails.action1.a5')}}</div><vs-list class="mb-3">
        </vs-list>
        </div>
      </vs-prompt>

      <div class="relative">
        <div class="items-center">
          <div class="vx-col w-full items-center footer-next">
            <div class="vx-card vx-card-next">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-card__body">
                  <div class="vx-row">
                    <div class="vx-col w-full mb-2">
                      <vs-button
                        v-if="endorsementInviteStep === 0"
                        class="w-full lg:w-1/2 md:w-1/2 add-skill-step-back-next"
                        color="primary"
                        type="filled"
                        :disabled="disabledNextButton"
                        @click="endorsementInviteStep = endorsementInviteStep + 1"
                      >{{ $t("endorsementInvite.ei1") }}</vs-button>

                      <vs-button
                        v-else-if="endorsementInviteStep === 1"
                        class="w-full lg:w-1/2 md:w-1/2 add-skill-step-back-next"
                        color="primary"
                        type="filled"
                        :disabled="disabledEndoInviteBtn"
                        @click="confirmSendEndorsementInvite = true"
                      >{{ $t("endorsementInvite.ei2") }}</vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import InvitePeople from "./InvitePeople";
  import ProgressMeasure from "./ProgressMeasure";
  
  import baseData from "@/i18n/i18n-en-Data-DPM.js";           
  import deepData from "@/i18n/i18n-en-deep-Data.js";       
  import pciData from "@/i18n/i18n-en-pci-Data-Coach.js";         
  import peopletreeData from "@/i18n/i18n-en-peopletree-Data.js"; 

  function getSkillNameFromSources(parentId) {
    const sources = [deepData, pciData, peopletreeData, baseData];
    let foundNames = [];

    for (const rawSrc of sources) {
      if (!rawSrc) continue;
      
      let rootData = null;
      if (rawSrc.addNewSkill && rawSrc.addNewSkill.data) rootData = rawSrc.addNewSkill.data;
      else if (rawSrc.default && rawSrc.default.addNewSkill && rawSrc.default.addNewSkill.data) rootData = rawSrc.default.addNewSkill.data;
      else if (rawSrc['sc']) rootData = rawSrc;
      else if (rawSrc.default && rawSrc.default['sc']) rootData = rawSrc.default;
      else if (rawSrc.data) rootData = rawSrc.data;
      else if (rawSrc.default && rawSrc.default.data) rootData = rawSrc.default.data;

      if (!rootData) continue;

      for (const key in rootData) {
        if (rootData[key] && rootData[key].competencies) {
          const match = rootData[key].competencies.find(c => c.id === parentId);
          if (match && match.comp && !foundNames.includes(match.comp)) {
            foundNames.push(match.comp);
          }
        }
      }
    }

    if (foundNames.length > 1) {
      const specializedName = foundNames.find(name => name !== 'Informing others');
      if (specializedName) return specializedName;
    }

    return foundNames.length > 0 ? foundNames[0] : null;
  }

  export default {
    name: "EndorsementInvite",
    data() {
      return {
      endorsementInviteStep: 0,
      CCD: this.$t("addNewSkill.data"),
      InviteSkillName: null,
      currentTraineeCompetencyIdStr: null, 
      feedbackFrequency: 15,
      coachingFrequency: 30,
      motivationFrequency: 30,
      scheduled_emails: [],
      feedback_sent_dates: [],
      sendMails: true,
      count: 0,
      universalCounter: 0,
      trainingDuration: null,
      firstName: '',
      lastName: '',
      activeConfirm: false,
      confirmSendEndorsementInvite: false,
      activeEmailIndex: null,
      activeSendCount: 0
    };
    },
    components: {
      ProgressMeasure,
      InvitePeople
    },
    computed: {
      disabledEndoInviteBtn() {
        return this.$store.state.endorsementInvite.progressMeasures.length === 0;
      },
      disabledNextButton() {
        return this.$store.state.endorsementInvite.emailList.length === 0;
      }
    },
    methods: {
      formatDate(sentDate) {
        let date = sentDate ? new Date(sentDate) : new Date();
        if (isNaN(date.getTime())) date = new Date(); 
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      },
      getUtils() {
        const uuid4 = require("uuid4");
        
        let durationStr = this.trainingDuration;
        if (!durationStr) {
           let futureDate = new Date();
           futureDate.setDate(futureDate.getDate() + 90); 
           durationStr = `${futureDate.getFullYear()}-${futureDate.getMonth() + 1}-${futureDate.getDate()}`;
        }
        
        const trainingDuration = durationStr.split("-");
        const timeUnit = 24 * 60 * 60 * 1000; 

        const endDate = new Date(
          parseInt(trainingDuration[0]),
          parseInt(trainingDuration[1]) - 1,
          parseInt(trainingDuration[2])
        );
        
        const startDate = new Date();

        this.scheduled_emails = [];
        this.feedback_sent_dates = [];

        const generateSchedule = (frequency, surveyType) => {
          if (!frequency || frequency <= 0) return; 
          
          // WE ONLY WANT ONE EMAIL NOW (The immediate one)
          let scheduleDate = new Date(startDate.getTime());
          
          if(scheduleDate <= endDate) {
             this.scheduled_emails.push({
               date: scheduleDate,
               type: surveyType,
               isBenchmark: true, // It's always the first one now
               token: uuid4()
             });
             
             if (surveyType === 'feedback') {
               this.feedback_sent_dates.push(scheduleDate);
             }
          }
        };

        generateSchedule(this.feedbackFrequency, 'feedback');
        
        // You can leave coaching/motivation alone or change them based on your business logic.
        // Assuming they also need to be dynamically scheduled later, we generate 1 for them too.
        // generateSchedule(this.coachingFrequency, 'coaching');
        // generateSchedule(this.motivationFrequency, 'motivation');
        
        console.log("🚀 [DEBUG] getUtils() Generated Emails:", this.scheduled_emails.length);
      },
      sendInviteMail(extFeedObj) {
        if (this.sendMails === true) {
          this.$store
            .dispatch("endorsementInvite/sendEmails", extFeedObj)
            .catch(err3 => console.log("error endo invite - error send emails", err3));
        }
      },
      async pushExternalFeedbacks(res1, res2, specificSkillName) {
        const createPromises = []; 
        
        console.log(`🚀 [DEBUG] pushExternalFeedbacks() triggered. Scheduled emails count: ${this.scheduled_emails.length}`);

        if(this.scheduled_emails.length === 0) {
           console.warn("⚠️ [DEBUG WARNING] scheduled_emails is EMPTY. No API requests will be sent!");
        }
        
        for (let i = 0; i < this.scheduled_emails.length; i++) {
          const emailList = this.$store.state.endorsementInvite.emailList;
          const schedule = this.scheduled_emails[i];
          
          let mailTypeLabel = schedule.isBenchmark ? "benchmark" : "followup";
          if (schedule.type !== 'feedback') mailTypeLabel = schedule.type; 

          const finalSkillName = specificSkillName || this.InviteSkillName;

          let extFeedObj = {
            traineeName: (this.firstName + ' ' + this.lastName).trim(),
            mailType: mailTypeLabel,
            flag: "feedback_invitation_send",
            inviteeEmail: emailList[this.activeEmailIndex].email,
            inviteUserName: emailList[this.activeEmailIndex].inviteUserName,
            trainingDuration: this.trainingDuration,
            skillName: finalSkillName,
            companyName: window.$cookies.get('companyName'),
            endorsementInvitePrgmsId: res2.id,
            externalToken: schedule.token, 
            traineeEmail: this.$store.state.AppActiveUser.email,
            emailStatus: 0,
            lang: ((window.$cookies.get('locale') == 'es') ? 'es' : 'en'),
            externalTokenExpired: false,
            feedbackSentDate: schedule.date, 
            surveyType: schedule.type 
          };

          if (this.activeSendCount === 1 && schedule.isBenchmark && schedule.type === 'feedback') {
            await this.$store.dispatch("endorsementInvite/sendEmails", extFeedObj).catch(err => {});
          }

          let dbPayload = Object.assign({}, extFeedObj);
          delete dbPayload.flag;
          delete dbPayload.mailType;
          dbPayload.notesDescription = "";
          dbPayload.followupCount = 0;
          
          console.log(`📩 [DEBUG] Sending to backend database:`, dbPayload.surveyType, dbPayload.feedbackSentDate);
          createPromises.push(this.$store.dispatch("external-feedback/create", dbPayload).catch(err3 => {}));
        }
        
        await Promise.all(createPromises);
      },
      async addEndorsementInvitePrgms(res1) {
        const progressMeasures = this.$store.state.endorsementInvite.progressMeasures;
        
        console.log(`🚀 [DEBUG] addEndorsementInvitePrgms() triggered. Progress measures:`, progressMeasures);

        if(!progressMeasures || progressMeasures.length === 0) {
           console.warn("⚠️ [DEBUG WARNING] progressMeasures is EMPTY! Inner loop will be skipped.");
        }
        
        let expectedParentId = null;
        if (this.currentTraineeCompetencyIdStr && this.currentTraineeCompetencyIdStr.includes('-')) {
             const parts = this.currentTraineeCompetencyIdStr.split("-");
             expectedParentId = parts[0] + "-" + parts[1];
        } else {
             expectedParentId = this.currentTraineeCompetencyIdStr;
        }

        for (const p in progressMeasures) {
          const pmId = progressMeasures[p]; 
          
          if (expectedParentId && pmId && typeof pmId === 'string' && !pmId.startsWith(expectedParentId)) {
             continue; 
          }
          
          this.activeSendCount += 1;

          const pmObj = {
            progressMeasureId: pmId,
            endorsementInviteId: res1.id
          };
          
          let resolvedSkillName = pmId; 
          if (pmId && typeof pmId === 'string' && pmId.includes('-')) {
             const parts = pmId.split("-");
             const parentId = parts[0] + "-" + parts[1]; 
             const foundName = getSkillNameFromSources(parentId);
             if (foundName) resolvedSkillName = foundName;
          }

          await this.$store
            .dispatch("endorsementInvite/sendEndorsementInvitePrgms", pmObj)
            .then(async res2 => {
              await this.pushExternalFeedbacks(res1, res2, resolvedSkillName);
            })
            .catch(err2 => {});
        }
        this.activeSendCount = 0;
      },
      async sendEndorsementInvite() {
        try {
          console.log("==========================================");
          console.log("🚀 [DEBUG] SUBMIT BUTTON CLICKED!");
          
          this.$vs.loading(); 
          this.$Progress.start();
          const emailList = this.$store.state.endorsementInvite.emailList;

          console.log("🚀 [DEBUG] Email List to send to:", emailList);
          if(!emailList || emailList.length === 0) {
             console.error("❌ [DEBUG ERROR] emailList is EMPTY! No emails will be sent.");
          }

          for (const e in emailList) {
            this.getUtils();
            this.activeEmailIndex = e;
            const endorsementInvite = {
              inviteeEmail: emailList[e].email,
              inviteUserName:emailList[e].inviteUserName,
              userId:this.$store.state.AppActiveUser.usersId,
              traineeCompetenciesId: parseInt(
                this.$route.params.traineeCompetenciesId
              ),
              companyName:window.$cookies.get('companyName'),
              skillName: this.InviteSkillName,
              status:0
            };
            
            console.log("🚀 [DEBUG] Dispatching primary endorsementInvite...");
            await this.$store
              .dispatch("endorsementInvite/sendEndorsementInvite", endorsementInvite)
              .then(async res1 => {
                this.sendMails = true;
                await this.addEndorsementInvitePrgms(res1);
                this.count = 0;
              })
              .catch(err1 => { console.error("Error creating initial invite:", err1); });
          }

        } catch (error) {
           console.error("❌ [DEBUG ERROR] Crash inside sendEndorsementInvite():", error);
        } finally {
          this.$Progress.finish();
          
          // Slight delay before closing loading and routing, to ensure DOM stabilizes 
          setTimeout(() => {
            this.$vs.loading.close();
            this.$router.push({
              name: "skill-details",
              params: { traineeCompetenciesId: this.$route.params.traineeCompetenciesId }
            });
          }, 500);
        }
      },
    },
    created() {
      try {
        const sources = [baseData, peopletreeData, pciData, deepData];
        let mergedData = {};
        
        const extractData = (rawSrc) => {
          if (!rawSrc) return null;
          if (rawSrc.addNewSkill && rawSrc.addNewSkill.data) return rawSrc.addNewSkill.data;
          if (rawSrc.default && rawSrc.default.addNewSkill && rawSrc.default.addNewSkill.data) return rawSrc.default.addNewSkill.data;
          if (rawSrc['sc']) return rawSrc;
          if (rawSrc.default && rawSrc.default['sc']) return rawSrc.default;
          if (rawSrc.data) return rawSrc.data;
          if (rawSrc.default && rawSrc.default.data) return rawSrc.default.data;
          return null;
        };

        for (const src of sources) {
          const data = extractData(src);
          if (!data) continue;
          for (const key in data) {
            if (!mergedData[key]) mergedData[key] = { competencies: [] };
            if (data[key] && data[key].competencies) {
              for (const comp of data[key].competencies) {
                const existingComp = mergedData[key].competencies.find(c => c.id === comp.id);
                if (existingComp) {
                  if (comp.progressMeasures && comp.progressMeasures.length > 0) {
                    existingComp.progressMeasures = JSON.parse(JSON.stringify(comp.progressMeasures));
                  }
                  if (comp.comp) {
                    existingComp.comp = comp.comp;
                  }
                } else {
                  mergedData[key].competencies.push(JSON.parse(JSON.stringify(comp)));
                }
              }
            }
          }
        }

        if (this.$i18n) {
          const locale = this.$i18n.locale || 'en';
          let msgs = this.$i18n.getLocaleMessage(locale);
          if (!msgs.addNewSkill) msgs.addNewSkill = {};
          msgs.addNewSkill.data = mergedData;
          this.$i18n.setLocaleMessage(locale, msgs);
          
          this.CCD = mergedData;
        }
      } catch (e) {
        console.error("Failed to merge specialized skill data", e);
      }

      this.$store.dispatch("endorsementInvite/destroyAllState").catch(err => {});
      const traineeCompetenciesId = this.$route.params.traineeCompetenciesId;
      
      const rawCompanyName = window.$cookies.get('companyName');
      const companyName = rawCompanyName ? decodeURIComponent(rawCompanyName) : null;
      
      console.log("🚀 [DEBUG] Company Name loaded:", companyName);

      if(companyName) {
        this.$store.dispatch('company/find', { query: { name: companyName } })
          .then(res => {
            const data = res.data ? res.data : res;
            if(data && data.length > 0) {
              const comp = data[0];
              
              const fbFreq = comp.feedbackFrequency !== undefined ? comp.feedbackFrequency : comp.feedback_frequency;
              this.feedbackFrequency = (fbFreq !== undefined && fbFreq !== null) ? parseInt(fbFreq) : 15;
              
              const cFreq = comp.coachingSurveyDays !== undefined ? comp.coachingSurveyDays : comp.coaching_survey_days;
              this.coachingFrequency = (cFreq !== undefined && cFreq !== null) ? parseInt(cFreq) : 30;
              
              const mFreq = comp.motivationSurveyDay !== undefined ? comp.motivationSurveyDay : comp.motivation_survey_day;
              this.motivationFrequency = (mFreq !== undefined && mFreq !== null) ? parseInt(mFreq) : 30;
              
              console.log("🚀 [DEBUG] Frequency Data Loaded -> Feedback:", this.feedbackFrequency, " Coaching:", this.coachingFrequency, " Motivation:", this.motivationFrequency);
              
              this.getUtils();
            }
          }).catch(err => { console.error("Error fetching company data:", err); });
      }

      this.$store
        .dispatch("trainee-competencies/get", traineeCompetenciesId)
        .then(res => {
          this.currentTraineeCompetencyIdStr = res.competencyId; 
          this.trainingDuration = res.trainingDuration;
          
          this.$store.dispatch("userManagement/fetchUser", res.usersId).then(response => {
              let userObj = response.data && response.data.length ? response.data[0] : response;
              this.firstName = userObj.firstName || '';
              this.lastName = userObj.lastName || '';
            }).catch(err => {});
            
          let foundTitle = null;
          if (res.competencyId && typeof res.competencyId === 'string' && res.competencyId.includes('-')) {
             const parts = res.competencyId.split("-");
             const parentId = parts[0] + "-" + parts[1];
             foundTitle = getSkillNameFromSources(parentId);
          }
          this.InviteSkillName = foundTitle || res.competencyId;
          this.getUtils();
        })
        .catch(err => {});
    }
  };
</script>

<style scoped>
  @media (max-width: 767px) {
    .footer-next {
      position: fixed;
      bottom: 0;
      width: 100vw;
      left: calc(-50vw + 50%);
    }
  }

  .vx-card-next {
    box-shadow: none;
    -webkit-box-shadow: none;
  }

  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
</style>